import axios from 'axios'
import i18n from '@/i18n'

const translateCommon = (key, params) => i18n.global.t(`common.${key}`, params)

// 创建axios实例
const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: parseInt(process.env.VUE_APP_API_TIMEOUT) || 10000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    
    // 添加token到请求头
    const token = localStorage.getItem('token')
    if (token && config.withToken !== false) {
      config.headers.Authorization = `Bearer ${token}`
    }
    
    // 添加请求时间戳
    config.headers['X-Request-Time'] = Date.now()
    
    // 打印请求信息（仅开发环境）
    if (process.env.VUE_APP_DEBUG === 'true') {
      console.log('🚀 Request:', {
        url: config.url,
        method: config.method,
        data: config.data,
        params: config.params
      })
    }
    
    return config
  },
  error => {
    // 对请求错误做些什么
    console.error('Request Error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    const { data, status } = response
    
    // 打印响应信息（仅开发环境）
    if (process.env.VUE_APP_DEBUG === 'true') {
      console.log('📦 Response:', {
        url: response.config.url,
        status,
        data
      })
    }
    
    // 统一处理响应数据格式
    if (status === 200) {
      // 根据后端API的数据结构调整
      if (data.code === 200 || data.success === true) {
        return Object.prototype.hasOwnProperty.call(data, 'data') ? data.data : data
      } else {
        // 业务错误
        const message = data.msg || data.message || translateCommon('requestFailed')
        console.error('Business Error:', message)
        // 可以在这里添加全局错误提示组件
        // ElMessage.error(message)
        return Promise.reject(new Error(message))
      }
    }
    
    return response
  },
  error => {
    // 对响应错误做点什么
    const { response } = error
    
    if (response) {
      const { status, data } = response
      let message = translateCommon('requestFailed')
      
      switch (status) {
        case 400:
          message = data.msg || data.message || translateCommon('badRequest')
          break
        case 401:
          message = translateCommon('unauthorized')
          // 清除token并跳转到登录页
          localStorage.removeItem('token')
          // 这里可以添加路由跳转逻辑
          break
        case 403:
          message = translateCommon('forbidden')
          break
        case 404:
          message = translateCommon('notFound')
          break
        case 500:
          message = translateCommon('serverError')
          break
        case 502:
          message = translateCommon('badGateway')
          break
        case 503:
          message = translateCommon('serviceUnavailable')
          break
        default:
          message = data.msg || data.message || translateCommon('requestFailedWithStatus', { status })
      }
      
      console.error('Response Error:', message, error)
      // 可以在这里添加全局错误提示组件
      // ElMessage.error(message)
    } else if (error.code === 'ECONNABORTED') {
      console.error('Request Timeout:', translateCommon('requestTimeout'))
      // ElMessage.error(translateCommon('requestTimeout'))
    } else {
      console.error('Network Error:', translateCommon('networkError'))
      // ElMessage.error(translateCommon('networkError'))
    }
    
    return Promise.reject(error)
  }
)

export default request 
